import Parse from 'react-html-parser';

const Questionaire = ({ data, language }) => {
    const euro_country = ['fr', 'it', 'gb', 'ch', 'es', 'de'];
    return euro_country.includes(language) ? <>{Parse(data)}</> : null;
};

export default Questionaire;
